import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import styles from '../styles.module.scss'
import { hasPDPLink } from '@/utils/product'

const NameLink = ({ item }) => {
    const showLink = useMemo(() => hasPDPLink(item), [item])

    if (showLink) {
        return (
            <a href={item.variantUrl} className={styles.itemName} data-selector={`cartItem_title_${item.sku}`}>
                {item.genericName}
            </a>
        )
    }

    return (
        <span className={styles.itemName} data-selector={`cartItem_title_${item.sku}`}>
            {item.genericName}
        </span>
    )
}

NameLink.propTypes = {
    item: PropTypes.object
}

export default NameLink
